import { ThemeStyles } from '@honda-canada/design-system-react';
import css from '@styled-system/css';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Container')(
  css({
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
    px: ['20px', '20px', 's'],
    gap: ['default', 'default', 'xl'],
  }),
);

themeStyles.addBaseStyles('Title')(
  css({
    fontFamily: 'bold',
    pb: 'xs',
  }),
);

themeStyles.addBaseStyles('Subtitle')(
  css({
    mb: 'm',
  }),
);

themeStyles.addBaseStyles('SwatchContainer')(
  css({
    display: 'grid',
    gridTemplateColumns: [
      'repeat(2, minmax(0, max-content))',
      'repeat(2, minmax(0, max-content))',
      'repeat(2, minmax(0, 1fr))',
    ],
    columnGap: ['l', 'l', 'xl'],
  }),
);

themeStyles.addBaseStyles('SwatchTitle')(
  css({
    fontFamily: 'bold',
  }),
);

themeStyles.addBaseStyles('Column')(
  css({
    flex: '1 1 0',
  }),
);

export default themeStyles;
